import DuplicateAccountListStore from '../store/DuplicateAccountListStore';

const useDuplicateAccountList = () => {
    const duplicates = DuplicateAccountListStore.useState((s) => s.duplicates);
    const hasDuplicates = DuplicateAccountListStore.useState((s) => s.hasDuplicates);
    const accountName = DuplicateAccountListStore.useState((s) => s.accountName);
    const accountId = DuplicateAccountListStore.useState((s) => s.accountId);
    const open = DuplicateAccountListStore.useState((s) => s.open);

    const getDuplicateAccounts = async (accountName: string, id: string) => {
        DuplicateAccountListStore.update((s) => {
            s.accountName = accountName;
            s.accountId = id;
        });

        const response = await fetch('/api/accounts/duplicates', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name: accountName, id: id }),
        });

        const data = await response.json();

        DuplicateAccountListStore.update((s) => {
            s.duplicates = data;
            s.hasDuplicates = data.length > 0;

            if (data.length > 0) {
                s.open = true;
            }
        });
    };

    const clearDuplicates = () => {
        DuplicateAccountListStore.update((s) => {
            s.duplicates = [];
            s.hasDuplicates = false;
            s.open = false;
            s.accountName = '';
            s.accountId = '';
        });
    };

    const updateAccountName = async (updatedName: string) => {
        await getDuplicateAccounts(updatedName, accountId);
    };

    const setOpen = () => {
        DuplicateAccountListStore.update((s) => {
            s.duplicates = [];
            s.hasDuplicates = false;
            s.open = true;
            s.accountName = '';
            s.accountId = crypto.randomUUID();
        });
    };

    return {
        getDuplicateAccounts,
        duplicates,
        hasDuplicates,
        clearDuplicates,
        accountName,
        accountId,
        updateAccountName,
        open,
        setOpen,
    };
};

export default useDuplicateAccountList;
